export type FeelLevel = 1 | 2 | 3 | 4 | 5;

export interface FeelProfile {
  name: string;
  slope: number;
  interceptMinutes: number;
  color: string;
}

export const FEEL_PROFILES: Record<FeelLevel, FeelProfile> = {
  1: { name: 'Pure Taxi', slope: 1.0, interceptMinutes: 5, color: '#1E88E5' },
  2: { name: 'Responsive', slope: 1.5, interceptMinutes: 10, color: '#00ACC1' },
  3: { name: 'Balanced', slope: 2.0, interceptMinutes: 15, color: '#43A047' },
  4: { name: 'Efficient', slope: 2.5, interceptMinutes: 30, color: '#FB8C00' },
  5: { name: 'Pure Bus', slope: 3.0, interceptMinutes: 45, color: '#E53935' },
};
